import { withTranslation } from 'react-i18next'
import Statistics from './Statistics'

export default withTranslation()(Statistics)
